import React, { Fragment } from 'react'
import { FIXED_INDENTS } from 'vars/index'
import {
  PaymentOptionCards,
  PaymentOptionPopupSC,
} from './PopupComponents.styled'

export interface IPaymentOptionPopup {
  children: React.ReactNode | React.ReactNode[]
  columnGap?: FIXED_INDENTS
  rowGap?: FIXED_INDENTS
}

export const PaymentOptionPopup = ({
  columnGap = FIXED_INDENTS.INDENT_40,
  rowGap = FIXED_INDENTS.INDENT_60,
  children,
}: IPaymentOptionPopup) => {
  const components = React.Children.toArray(children)
  const hasOnePaymentOption: boolean = components.length === 2
  const sliceIndex = hasOnePaymentOption ? 1 : -1
  const bodyChild = components.slice(0, sliceIndex)
  const lastChild: React.ReactNode = components.slice(-1)

  return (
    <PaymentOptionPopupSC rowGap={rowGap}>
      <PaymentOptionCards
        columnGap={columnGap}
        hasOnePaymentOption={hasOnePaymentOption}
      >
        {bodyChild.map((item, index) => (
          <Fragment key={index}>{item}</Fragment>
        ))}
      </PaymentOptionCards>
      {lastChild}
    </PaymentOptionPopupSC>
  )
}
